export enum BillingAccountDateType {
  CREATED_AT = "CREATED_AT",
  DOC_DATE = "DOC_DATE"
}
